'use client';

import { Header } from '@/components/layout/Header';
import { vstack } from '@onbeam/business-styled-system/patterns';
import { useHeroScrollAnimation } from '../Hero/useHeroScrollAnimation';
import { css } from '@onbeam/business-styled-system/css';

export const HomeHeader = () => {
  const scrollProgress = useHeroScrollAnimation((state) => state.progress);

  const opacity = Math.max(0, (scrollProgress - 0.5) * 2);

  return (
    <header
      data-finished={scrollProgress >= 1}
      className={vstack({
        '&[data-finished="false"]': {
          h: '[140vh]',
          zIndex: '-1',
        },
      })}
      style={{ opacity }}
    >
      <Header
        as="div"
        css={css.raw({
          position: 'sticky',
          top: '0',
        })}
      />
    </header>
  );
};
